define([
    "dojo/_base/declare",
    "csi/xml",
    "Workflow/UTCController"
], function(declare,xml,UTCController) {

    var CFCA_DIGITAL_SIGNATURE = "CFCADigitalSignature";

    return declare(UTCController, {

        toWriter: function() {
            var call = this.inherited(arguments);

            var fd = this.m_formData;
            if (fd) {
                var signature = fd.getFieldValue(CFCA_DIGITAL_SIGNATURE, true);
                var node = fd.getNode();

                this.m_writer.changeNode(node.$URL)
                                .changeAttribute(CFCA_DIGITAL_SIGNATURE, xml.ATTR_STRING, signature);

                this.m_writer.callMethod("CFCA", "VerifyDigitalSignatureOnActionItemStepResponse")
                                .addParameter("URL", xml.ATTR_CNL, node.$URL);
            }
            return call;
        }
    });
});
